import React from 'react';
import { Carousel } from '@xo-union/ui-carousel';
import { Room } from '../../libs/gs-component-hotel-planner';
import { NextButton, PrevButton } from './Buttons';
import TransientRoom from './TransientRoom';

interface Props {
  onClick: (room: Room) => void;
  rooms: Room[];
}

const HotelPlannerCarousel: React.FC<Props> = ({ rooms, onClick }) => {
  if (rooms.length === 0) {
    return null;
  }
  return (
    <Carousel
      gutter={16}
      minSlideWidth={158}
      maxSlideWidth={160}
      renderNextButton={NextButton}
      renderPrevButton={PrevButton}
    >
      {rooms.map((room, index) => (
        <TransientRoom room={room} onClick={onClick} key={index} />
      ))}
    </Carousel>
  );
};

export default HotelPlannerCarousel;
